import { IssuesList } from './IssuesList';
import { IssueVisibilityType } from '@sonar-software/sonar-issues';
import React from 'react';
export const SnoozedIssuesList = () => React.createElement(IssuesList, { visibility: IssueVisibilityType.Snoozed });
